import { validateBusinessName } from '../../../utils/validations';
import messages from './messages';

// The legacy commercial Edit Occupant form's labels, kept verbatim so the
// tenant sees the same names for the same columns.
export const COMMERCIAL_GENERAL_LABELS = {
  firstName: 'Tenant Legal Name',
  preferredName: 'DBA(Doing Business As)',
  parentCompany: 'Parent Company',
  phoneNumber: 'Phone',
  emailAddress: 'Email Address',
  street: 'Address',
  street2: 'Address 2',
  city: 'City',
  state: 'State / Province',
  zipCode: 'Zip Code / Postal Code',
};

// A blank passes so `required` stays the only rule that blocks an empty
// Tenant Legal Name; DBA is optional and must not fail on empty.
export const validateCommercialName = (value) =>
  !value || Boolean(validateBusinessName(value)) || 'Invalid Name';

// Paired md:6 avoids the orphan rows the legacy col-sm-N widths left in the
// wider SectionedModal (lone Email, half-width Annual Income). Rules/props
// are passed in from useMiniProfileSections's closure, like demographicFields.
export const buildCommercialGeneralFields = ({
  states = [],
  phoneFieldRules,
  emailFieldRules,
  annualIncomeValidate,
  clearableSelectProps,
  formatMessage,
}) => [
  {
    variant: 'text',
    name: 'generalInformation.firstName',
    label: COMMERCIAL_GENERAL_LABELS.firstName,
    rules: { required: true, validate: validateCommercialName },
    GridProps: { xs: 12, md: 6 },
  },
  {
    variant: 'text',
    name: 'generalInformation.preferredName',
    label: COMMERCIAL_GENERAL_LABELS.preferredName,
    rules: { validate: validateCommercialName },
    GridProps: { xs: 12, md: 6 },
  },
  {
    variant: 'text',
    name: 'generalInformation.parentCompany',
    label: COMMERCIAL_GENERAL_LABELS.parentCompany,
    GridProps: { xs: 12, md: 6 },
  },
  // Reserves Parent Company's paired half so Phone doesn't reflow into the
  // gap left by moving Annual Income to the end. `xs: 0` on phone widths,
  // where rows are already full-width; padding zeroed so it adds no height.
  {
    variant: 'custom',
    name: 'parentCompanyRowSpacer',
    component: null,
    GridProps: { xs: 0, md: 6, sx: { p: 0 } },
  },
  {
    variant: 'phone',
    name: 'generalInformation.phoneNumber',
    label: COMMERCIAL_GENERAL_LABELS.phoneNumber,
    rules: phoneFieldRules,
    GridProps: { xs: 12, md: 6 },
  },
  {
    variant: 'email',
    name: 'generalInformation.emailAddress',
    label: COMMERCIAL_GENERAL_LABELS.emailAddress,
    rules: emailFieldRules,
    GridProps: { xs: 12, md: 6 },
  },
  {
    variant: 'text',
    name: 'generalInformation.street',
    label: COMMERCIAL_GENERAL_LABELS.street,
    GridProps: { xs: 12, md: 6 },
  },
  {
    variant: 'text',
    name: 'generalInformation.street2',
    label: COMMERCIAL_GENERAL_LABELS.street2,
    GridProps: { xs: 12, md: 6 },
  },
  {
    variant: 'text',
    name: 'generalInformation.city',
    label: COMMERCIAL_GENERAL_LABELS.city,
    GridProps: { xs: 12, md: 6 },
  },
  {
    variant: 'singleSelect',
    name: 'generalInformation.state',
    label: COMMERCIAL_GENERAL_LABELS.state,
    ...clearableSelectProps(states),
    placeholder: 'Choose',
    GridProps: { xs: 12, md: 3 },
  },
  {
    variant: 'text',
    name: 'generalInformation.zipCode',
    label: COMMERCIAL_GENERAL_LABELS.zipCode,
    GridProps: { xs: 12, md: 3 },
  },
  {
    variant: 'currency',
    name: 'personalInformation.annualIncome',
    label: formatMessage(messages.annualIncome),
    placeholder: '0.00',
    rules: { validate: annualIncomeValidate },
    GridProps: { xs: 12, md: 6 },
  },
];

export const COMMERCIAL_GENERAL_FIELD_NAMES = buildCommercialGeneralFields({
  clearableSelectProps: () => ({}),
  formatMessage: () => '',
}).map((field) => field.name);

export default buildCommercialGeneralFields;
